export const SET_IS_SAFARI = "SET_IS_SAFARI";
